import type { HelpFile } from '../../types/help'
import { ImpersonationBannerTestIds } from '../../../testids/ImpersonationBannerTestIds'

export const impersonationBannerHelp: HelpFile = {
  docPage: '/docs/admin/impersonation',
  texts: {
    [ImpersonationBannerTestIds.impersonatedUserName]: 'Aktive Stellvertretungssitzung — alle Aktionen werden im Audit-Log der echten Identität zugeordnet.',
    [ImpersonationBannerTestIds.btnSwitchBack]: 'Stellvertretung beenden und zum eigenen Konto zurückkehren.',
  },
}
